import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-729da98a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chatbot-container" }
const _hoisted_2 = {
  key: 0,
  class: "pi pi-chevron-down text-xl"
}
const _hoisted_3 = {
  key: 1,
  class: "pi pi-comment text-xl"
}
const _hoisted_4 = {
  key: 0,
  class: "chat-panel"
}
const _hoisted_5 = { class: "chat-header" }
const _hoisted_6 = { class: "chat-header-logo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "webchat-container" }
const _hoisted_11 = {
  key: 0,
  class: "chat-header-logo small"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "flex gap-2 align-items-end"
}
const _hoisted_14 = { class: "chat-header-logo small" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message incoming" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    height: "30",
    width: "40",
    class: "loader"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      class: "dot",
      cx: "10",
      cy: "20",
      r: "3"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      class: "dot",
      cx: "20",
      cy: "20",
      r: "3"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      class: "dot",
      cx: "30",
      cy: "20",
      r: "3"
    })
  ])
], -1))
const _hoisted_17 = { class: "chat-input-container" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-send" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueShowdown = _resolveComponent("VueShowdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "chat-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleChat && _ctx.toggleChat(...args)))
    }, [
      (_ctx.isChatOpen)
        ? (_openBlock(), _createElementBlock("i", _hoisted_2))
        : (_openBlock(), _createElementBlock("i", _hoisted_3))
    ]),
    _createVNode(_Transition, { name: "chat-panel" }, {
      default: _withCtx(() => [
        (_ctx.isChatOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.storageUrl + '/logo.png',
                    alt: ""
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("chatbot.title")), 1),
                _createElementVNode("button", {
                  class: "close-button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleChat && _ctx.toggleChat(...args)))
                }, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allMessages, (message, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flex gap-2 align-items-end"
                  }, [
                    (message.type === 'incoming')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("img", {
                            src: _ctx.storageUrl + '/logo.png',
                            alt: ""
                          }, null, 8, _hoisted_12)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass([
                'message',
                message.type === 'outgoing' ? 'outgoing' : 'incoming',
              ])
                    }, [
                      _createVNode(_component_VueShowdown, {
                        markdown: _ctx.sanitizedMessage(message.text),
                        options: { emoji: true }
                      }, null, 8, ["markdown"])
                    ], 2)
                  ]))
                }), 128)),
                (_ctx.isTyping || _ctx.allMessages.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          src: _ctx.storageUrl + '/logo.png',
                          alt: ""
                        }, null, 8, _hoisted_15)
                      ]),
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.messageText) = $event)),
                  type: "text",
                  placeholder: _ctx.$t('chatbot.message'),
                  onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["enter"])),
                  class: "message-input"
                }, null, 40, _hoisted_18), [
                  [_vModelText, _ctx.messageText]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
                  class: "send-button"
                }, _hoisted_20)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}